import TransfersTable from './TransfersTable';

export default TransfersTable;
